const SiteMetadata = {
  title: 'ChouxBox',
  description: 'the sweetest way to manage your cabbage',
  pages: {
    chouxcrew: {
      title: 'The Chouxcrew',
      description: 'Know more about the crew behind ChouxBox'
    },
    whyChouxbox: {
      title: 'Why Chouxbox?',
      description: 'See the benefits of using ChouxBox'
    },
    privacyPolicy: {
      title: 'Privacy Policy',
      description: 'ChouxBox Privacy Policy'
    },
    termsOfService: {
      title: 'Terms of Service',
      description: 'ChouxBox Terms of Service'
    },
    thanks: {
      title: 'Thank you!',
      description: 'Thanks for signing up!'
    },
    notFound: {
      title: 'Not Found',
      description: '404 Page Not Found'
    }
  }
}

export default SiteMetadata



// WEBPACK FOOTER //
// ./src/SiteMetadata.js